import { useEffect } from "react";

import { useAppSelector } from "app/redux-store-interactions";
import {
    HighlightCollection,
    highlightCollectionsActions,
    useDispatchHighlightCollections,
    useLazyHighlightCollections,
} from "contexts/highlightCollections";
import { useHighlighted } from "contexts/highlighted";

import { ObjectVisibility } from "..";
import { selectDefaultVisibility } from "../renderSlice";

export function useUpdateTransparentSelectionBase() {
    const visibility = useAppSelector(selectDefaultVisibility);
    const isTransparentMode = visibility === ObjectVisibility.Transparent;
    const dispatchHighlightCollection = useDispatchHighlightCollections();
    const highlightedCollections = useLazyHighlightCollections();
    const highlightedIdArr = useHighlighted().idArr;

    useEffect(() => {
        const transparentSelectionBase = highlightedCollections.current[HighlightCollection.TransparentSelectionBase];
        if (isTransparentMode) {
            // If more objects selected - add them to the base, so they behave the same way
            const moreIds = highlightedIdArr.filter((id) => !transparentSelectionBase.ids[id]);
            if (moreIds.length === 0) {
                return;
            }

            dispatchHighlightCollection(
                highlightCollectionsActions.add(HighlightCollection.TransparentSelectionBase, moreIds),
            );
        } else if (transparentSelectionBase.idArr.length > 0) {
            dispatchHighlightCollection(
                highlightCollectionsActions.setIds(HighlightCollection.TransparentSelectionBase, []),
            );
        }
    }, [dispatchHighlightCollection, highlightedIdArr, highlightedCollections, isTransparentMode]);
}
